import { useCallback } from "react";
import { useTheme } from "next-themes";

import { useTranslation } from "@/lib/i18n";
import Button from "@/components/button/button";

import NavigationItem from "./navigation-item";
import styles from "./navigation.module.css";

export default function NavigationDarkModeToggle() {
  const { t } = useTranslation();
  const { resolvedTheme, setTheme } = useTheme();

  const toggleTheme = useCallback(() => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  }, [setTheme]);

  return (
    <Button onClick={toggleTheme} className={styles.navigationButton}>
      <NavigationItem icon={resolvedTheme === "dark" ? "toggle-right" : "toggle-left"}>
        {t("menu.darkmode")}
      </NavigationItem>
    </Button>
  );
}
